module.exports = __webpack_public_path__ + "static/img-cvs-catch-educators-implementation-train-96f7a5844a79731750b31b3f1d3d220f.jpg";